import React from 'react';
import { Button, Input, VStack } from '@chakra-ui/react';
import { useQuery } from '@apollo/client';
import { JobSeeker } from '~/generated';
import { myProfile } from '~/queries';
import { notifyClipboardCopySuccess } from '~/components/atoms';

const IntroduceUrlCopyButton = (): JSX.Element => {
  const { data } = useQuery<{ jobSeekerMe: JobSeeker }>(myProfile);

  const url = `${window.location.origin}?code=${data?.jobSeekerMe.id || ''}`;

  const handleOnClick = async () => {
    await navigator.clipboard.writeText(url);
    notifyClipboardCopySuccess();
  };

  return (
    <VStack flexGrow={1} align="stretch">
      <Input value={url} h="48px" />
      <Button size="lg" colorScheme="blue" onClick={handleOnClick}>
        紹介用URLをコピー
      </Button>
    </VStack>
  );
};

export default IntroduceUrlCopyButton;
